<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Tech Geek Ed. 6
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/techgeek/tech-geek-6-bannerimg.png" alt="Manager"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI Models 2026:</strong> Frontier AI is now multi-model, agentic, and cost-efficient with open-source
          models (Qwen, Kimi, MiniMax) rivaling proprietary giants (GPT-5.4, Gemini 3.1, Claude Opus)
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI Agents to Humanoid Workers:</strong> AI has evolved from assistants to autonomous agents and
          physical robots, entering workplaces, healthcare, and governance
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI Breakthroughs 2026:</strong> Key shifts include low-cost high-performance AI, wearable AI,
          scientific discovery automation, and smarter assistants
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI in Real-World Workflows:</strong> AI is now operational at scale with autonomous agents, enterprise
          integrations, and industrial robots redefining workforce dynamics
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>PromptLock Cyber Threat:</strong> First AI-powered ransomware introduces adaptive, intelligent
          cyberattacks, signaling the rise of AI vs AI cybersecurity
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI in Motion & Robotics:</strong> AI-powered robotics (microbots, dancing arms) and hardware
          investments (chips, humanoids) show AI expanding into physical and infrastructure layers
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Chrome Extensions for Productivity:</strong> Browser extensions now act as AI productivity tools
          improving focus, automation, and privacy
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Social Media Evolution 2025:</strong> Shift from mass platforms to community-driven, decentralized,
          and creator-owned ecosystems
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Clicks Productivity Devices:</strong> Hardware like Clicks Communicator & Power Keyboard reintroduces
          focused, distraction-free digital productivity
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AlterEgo Wearable AI:</strong> Silent communication via “neuromuscular signals” indicates the future
          of thought-based human-computer interaction
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>SwitchBot Onero H1 Robot:</strong> Multi-functional home robots mark the shift from single-task
          automation to general-purpose robotics
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI Browsers 2026:</strong> Browsers are evolving into AI-powered agents capable of research,
          automation, and task execution
        </p>
      </div>

    </div>
  </div>
</section>

<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>AI is shifting from LLMs to agentic ecosystems capable of planning, executing, and self-correcting tasks</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>Open-source AI vs proprietary AI gap is closing, driving affordability and innovation</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>AI is becoming physical (robots) + contextual (agents) + embedded (wearables)</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>Enterprise AI adoption is accelerating with real-world workflow automation</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>Cybersecurity is entering an AI vs AI battle, requiring adaptive defense systems</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>Human-AI interaction is evolving from screens → voice → silent/thought-based interfaces</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>AI hardware (chips, robotics) is now as critical as software innovation</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>The web is transforming into an AI-assisted environment via browsers and extensions</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>Social media is shifting toward authenticity, decentralization, and creator ownership</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>Consumer tech is trending toward focus, minimalism, and productivity-first design</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>Robotics is moving toward general-purpose assistants across industries and homes</p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>The future stack = AI models + agents + interfaces + hardware + ecosystems</p>
      </div>

    </div>

    <button class="btn case-study-btn" (click)="openModal()">
      Access Your Copy
    </button>
  </div>
</section>
<!-- Relevant Article -->
<app-relevant-techgeek></app-relevant-techgeek>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Access Your TechGeek Copy</h3>
      <p>Fill in your details to receive the Tech Geek Edition 6.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>